let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lBZIH")).then(() => parcelRequire('6ZxwT'));